/* eslint-disable camelcase */
import axios from '@axios'

export const state = {
  campaigns: [],
  decryptedCampaigns: [],
  drafts: [],
  trashes: [],
  exportReports: [],
  exportCurrentPage: 1,
  exportPerPage: 15,
  exportTotalPages: 1,
  exportTotalRecords: 0,
  currentPage: 1,
  perPage: 15,
  totalPages: 1,
  totalRecords: 0,
}

export const getters = {
  allCampaigns: (state) => state.campaigns,
  allDrafts: (state) => state.drafts,
  allTrashes: (state) => state.trashes,
  allExportReports: (state) => state.exportReports,
  exportCurrentPage: (state) => state.exportCurrentPage,
  exportPerPage: (state) => state.exportPerPage,
  exportTotalPages: (state) => state.exportTotalPages,
  exportTotalRecords: (state) => state.exportTotalRecords,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalCampaign: (state) => state.totalCampaign,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  RESET_PAGINATE_AND_STATE: (state) => {
    state.campaigns = []
    state.decryptedCampaigns = []
    state.drafts = []
    state.trashes = []
    state.currentPage = 1
    state.perPage = 15
    state.totalPages = 1
    state.totalRecords = 0
  },
  GET_CAMPAIGNS: (state, data) => {
    if (!data) {
      state.campaigns = []
      state.currentPage = 1
      state.perPage = 15
      state.totalPages = 1
      state.totalRecords = 0
      return false
    }
    state.campaigns = Array.isArray(data.campaigns) ? data.campaigns : []
    state.currentPage =
      typeof data.page === 'number' ? data.page : state.currentPage
    state.perPage =
      typeof data.perPage === 'number' ? data.perPage : state.perPage
    state.totalPages = data.totalPages
    state.totalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.totalRecords
  },
  CREATE_CAMPAIGN: (state, campaign) => {
    state.campaigns = state.campaigns.filter((cam) => cam.id !== campaign.id)
    state.campaigns.unshift(campaign)
  },

  CANCEL_CAMPAIGN: (state, campaign) => {
    state.campaigns = state.campaigns.filter((camp) => camp.id !== campaign.id)
    state.campaigns.unshift(campaign)
  },

  REMOVE_CAMPAIGN: (state, deletedCampaign) => {
    state.campaigns = state.campaigns.filter(
      (campaign) => campaign.id !== deletedCampaign.id
    )
  },

  // Draft
  GET_DRAFTS: (state, data) => {
    if (!data) return false
    state.drafts = Array.isArray(data.campaigns) ? data.campaigns : []
    state.currentPage =
      typeof data.page === 'number' ? data.page : state.currentPage
    state.perPage =
      typeof data.perPage === 'number' ? data.perPage : state.perPage
    state.totalPage =
      typeof data.totalPages === 'number' ? data.totalPages : state.totalPage
    state.totalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.totalRecords
  },
  CREATE_DRAFT: (state, draft) => {
    state.drafts.unshift(draft)
  },
  UPDATE_DRAFT: (state, editedDraft) => {
    state.drafts = state.drafts.filter((draft) => draft.id !== editedDraft.id)
    state.drafts.unshift(editedDraft)
  },
  REMOVE_DRAFT: (state, deletedDraft) => {
    state.drafts = state.drafts.filter((draft) => draft.id !== deletedDraft.id)
  },
  SEND_DRAFT: (state, sentDraft) => {
    state.drafts = state.drafts.filter((draft) => draft.id !== sentDraft.id)
  },

  // Trash
  GET_TRASHES: (state, data) => {
    if (!data) return false
    state.trashes = Array.isArray(data.campaigns) ? data.campaigns : []
    state.currentPage =
      typeof data.page === 'number' ? data.page : state.currentPage
    state.perPage =
      typeof data.perPage === 'number' ? data.perPage : state.perPage
    state.totalPage =
      typeof data.totalPages === 'number' ? data.totalPages : state.totalPage
    state.totalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.totalRecords
  },
  RESTORE_TRASH: (state, restored) => {
    state.trashes = state.trashes.filter((t) => t.id !== restored.id)
  },
  REMOVE_TRASH: (state, trash) => {
    state.trashes = state.trashes.filter((r) => r.id !== trash.id)
  },
  GET_EXPORT_REPORTS: (state, data) => {
    if (!data) {
      state.exportReports = []
      state.exportCurrentPage = 1
      state.exportPerPage = 15
      state.exportTotalPages = 1
      state.exportTotalRecords = 0
      return
    }
    state.exportReports = Array.isArray(data.reports) ? data.reports : []
    state.exportCurrentPage =
      typeof data.page === 'number' ? data.page : state.exportCurrentPage
    state.exportPerPage =
      typeof data.perPage === 'number' ? data.perPage : state.exportPerPage
    state.exportTotalPages =
      typeof data.totalPages === 'number'
        ? data.totalPages
        : state.exportTotalPages
    state.exportTotalRecords =
      typeof data.totalRecords === 'number'
        ? data.totalRecords
        : state.exportTotalRecords
  },
  REMOVE_EXPORT_REPORT: (state, report) => {
    if (!report || typeof report.id === 'undefined') return
    state.exportReports = state.exportReports.filter(
      (item) => item.id !== report.id
    )
  },
}

export const actions = {
  async getCampaigns({ commit, dispatch }, params = {}) {
    dispatch('layout/changeLoading', true, { root: true })
    params = { ...params, ...{ type: 'campaign' } }
    await axios
      .get(`/sms/campaigns`, { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          let data = resp.data
          commit('GET_CAMPAIGNS', data)
          dispatch('layout/changeLoading', false, { root: true })
        }
      })
      .catch(() => {
        commit('GET_CAMPAIGNS', null)
      })
      .finally(() => {
        dispatch('layout/changeLoading', false, { root: true })
      })
  },
  async getCampaign({ commit, dispatch }, id) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${id}`)
  },
  async getRecipientByCampaignId({ commit, dispatch }, { draft, paginate }) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${draft.id}/recipients`, {
      params: paginate,
    })
  },

  async decryptCampaign({ commit, dispatch }, campaign) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.get(`/sms/campaigns/${campaign.id}/decode`)
  },

  async encryptCampaign({ commit, dispatch }, campaign) {
    commit('GET_CAMPAIGNS', null)
  },

  async calculatePrice({ commit, dispatch }, campaign) {
    dispatch('layout/changeLoading', true, { root: true })
    return axios.post('/sms/campaigns/estimate', campaign)
  },
  async createCampaign({ commit }, campaign) {
    campaign.type = 'campaign'
    await axios.post(`/sms/campaigns`, campaign).then(resp => {
      if (resp.status === 201) {
        commit('CREATE_CAMPAIGN', resp.data)
      }
    })
  },
  async cancelCampaign({ commit, dispatch }, campaignId) {
    axios.patch(`/sms/campaigns/${campaignId}/cancel`).then((resp) => {
      if (resp.status === 200) {
        commit('CANCEL_CAMPAIGN', resp.data)
      }
    })
  },
  async saveCampaign({ commit, dispatch }, campaign) {
    // overwriting the campaign type to draft
    campaign.type = 'draft'

    return axios.post(`/sms/campaigns`, campaign)
  },
  async importCampaign({ commit, dispatch }, file) {
    dispatch('layout/changeLoading', true, { root: true })
    let form = new FormData()
    form.append('file', file)
    return axios.post('/sms/campaigns/import', form)
  },
  async exportCampaign({ commit }, { campaign, params }) {
    return axios.post(`/sms/campaign/export/${campaign.id}`, params)
  },
  async getExportReports({ commit }, params = {}) {
    const query = { perPage: 15, ...params }
    await axios.get('/sms/campaign/exports', { params: query }).then((res) => {
      if (res.status === 200) {
        commit('GET_EXPORT_REPORTS', res.data)
      }
    })
  },
  async removeExportReport({ commit }, exportId) {
    return axios
      .delete(`/users/profile/upload-document/${exportId}`)
      .then((res) => {
        if (res.status === 204) {
          commit('REMOVE_EXPORT_REPORT', { id: exportId })
        }
      })
  },
}
